import './App.css';
import "./styles/index.scss";
import * as React from "react";
import { Routes,Route} from "react-router-dom";
import {SlackPage} from './slacklanding/slackLanding';
import {SlackSuccess} from './slacklanding/slackThanks';
import {SlackWaiting} from './slacklanding/slackwaiting';




function App() {


  return (
    <Routes>
     <Route path="/" element={<SlackPage/>}/>
     <Route path="/slack" element={<SlackPage/>}/>
     <Route path="/slackthanks" element={<SlackSuccess/>}/>
     <Route path="/waitingPage" element={<SlackWaiting/>}/>

     
    </Routes>
  );
}

export default App;
